'use strict';

const P = require('./protocol.js');

const art = require('./visual/artwork-map.json');

const {
  createVisuals
} = require('./opener-surface.js'); // Explicit installation by the existing authenticated SDK integration. Nothing is installed by import.


function createRuntime({
  request,
  writesEnabled = false,
  openingEnabled = false,
  scopeKey,
  storage,
  makeRequestId,
  payment,
  host,
  ensureVendors,
  refreshActivity
} = {}) {
  P.check(P.id(scopeKey) && storage && typeof makeRequestId === 'function', 'AUTH_SCOPE_REQUIRED');
  const api = P.createAPI({
    request,
    writesEnabled,
    openingEnabled
  });
  const catalogues = new Map();
  const rawCatalogue = api.catalogue;
  const boundAPI = Object.freeze({ ...api,
    catalogue: async hash => {
      const value = await rawCatalogue(hash);
      catalogues.set(value.catalogueHash, value);
      return value;
    }
  });

  function artwork(cardId, styleId) {
    var _art$cards$String;

    P.check(/^OP[0-9]{3}$/.test(cardId), 'INVALID_ART_CARD');
    const style = (_art$cards$String = art.cards[String(Number(cardId.slice(2)))]) === null || _art$cards$String === void 0 ? void 0 : _art$cards$String.find(s => s.styleId === styleId || s.sourceStem === styleId);
    return style || null;
  }

  function boundOutcome(outcome) {
    const catalogue = catalogues.get(outcome.catalogueHash);
    P.check(catalogue, 'CATALOGUE_BINDING_REQUIRED');
    const card = catalogue.cards.find(c => c.cardId === outcome.cardId),
          style = artwork(outcome.cardId, outcome.styleId);
    P.check(card && card.styles.includes(outcome.styleId) && style, 'UNKNOWN_FROZEN_STYLE');
    P.check(P.canonical(card.rewards) === P.canonical(outcome.rewards), 'REWARD_DESCRIPTION_MISMATCH');
    return {
      card: { ...card,
        id: Number(card.cardId.slice(2))
      },
      style
    };
  }

  async function resolveOutcome(outcome) {
    if (!catalogues.has(outcome.catalogueHash)) await boundAPI.catalogue(outcome.catalogueHash);
    return boundOutcome(outcome);
  }

  return Object.freeze({
    api: boundAPI,
    scopeKey,
    storage,
    makeRequestId,
    payment,
    refreshActivity: typeof refreshActivity === 'function' ? async () => {
      const a = await refreshActivity();
      P.check(a === null || P.id(a.activityId) && Number.isSafeInteger(a.nextStep) && a.nextStep >= 1 && a.nextStep <= 7, 'INVALID_ACTIVITY_PROGRESS');
      return a;
    } : null,
    artwork,
    resolveOutcome,
    describeReward: o => {
      try {
        return boundOutcome(o).card.rewardText;
      } catch {
        return '獎勵明細待確認；請查詢同一卡包。';
      }
    },
    visuals: host ? createVisuals({
      host,
      ensureVendors
    }) : null
  });
}

module.exports = {
  createRuntime
};
